/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SmsCreditApi } from '../api/smscredit.api';
import { switchMap, map } from 'rxjs/operators';
import { SmsCreditData, SmsCredit } from '../../../interfaces/masters/smscredit';

@Injectable()
export class SmsCreditService extends SmsCreditData {

  constructor(private api: SmsCreditApi) {
    super();
  }

  getall(url: string): Observable<SmsCredit[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<SmsCredit>{
      return this.api.getby_id(url);
  }

  create(url: string, data:SmsCredit): Observable<SmsCredit[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:SmsCredit): Observable<SmsCredit> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
